<template>
  <b-navbar toggleable="md" variant="white" type="light">
    <b-navbar-brand href="#" to="/">BOS Partners</b-navbar-brand>
    <b-navbar-toggle target="colapse-nav"></b-navbar-toggle>
    <b-collapse is-nav id="colapse-nav">
      <b-navbar-nav class="ml-auto" right>
        <b-nav-item-dropdown :text="$store.getters['auth/userName']" right>
          <b-dropdown-item href="#" :to="{name:'profile'}">
            <i class="fas fa-user"></i>
            My Account
          </b-dropdown-item>
          <b-dropdown-item href="#" :to="{name:'organization'}">
            <i class="fas fa-building"></i>
            Organization
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="#" @click="logout">
            <i class="fas fa-sign-out-alt"></i>
            Logout
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  computed: {
    isLoggedIn: function() {
      return this.$store.getters["auth/isAuthenticated"];
    }
  },
  methods: {
    logout: function() {
      this.$store
        .dispatch("auth/logout")
        .then(() => {})
        .catch(err => {})
        .then(() => {
          this.$router.push("/login");
        });
    }
  }
};
</script>

<style>
</style>